import React, { useState } from 'react';
import { Button, TextField, Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { getDate } from '../../helpers/helperFunction.js'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const FilterPanel = ({ onFilter, onReset, className, isFromDateToDate }) => {
    const [searchValue, setSearchValue] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleFilter = () => {
        onFilter({
            search: searchValue,
            fromDate: getDate(fromDate),
            toDate: getDate(toDate)
        });
    };

    const handleReset = () => {
        setSearchValue('');
        setFromDate(null);
        setToDate(null);
        onReset();
    };

    return (
        <div className={className}>
            <div className="card">
                <div className="card-body">
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="Search"
                                variant="outlined"
                                value={searchValue}
                                onChange={handleSearchChange}
                                fullWidth
                            />
                        </Grid>
                        {isFromDateToDate && <><Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From Date"
                                    value={fromDate}
                                    onChange={handleFromDateChange}
                                    renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                            <Grid item xs={12} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        onChange={handleToDateChange}
                                    disableFuture
                                        renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </>
                        }


                    </Grid>
                    <div className='mt-3'>
                        <Grid item xs={4} md={3}>
                            <button className='btn btn-primary greeen-btn md_btn' onClick={handleFilter} fullWidth>
                                <span><FilterAltOutlinedIcon /></span> Filter
                            </button>
                            <button className="btn btn-light grey-btn md_btn me-0" onClick={handleReset} >
                                <span><i className="bi bi-funnel"></i></span>Reset</button>
                        </Grid>
                        <Grid item xs={6} md={3}>

                        </Grid>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default FilterPanel;
